import CardProfile from "./CardProfile";

export {
    CardProfile
};